/**
 * Ajuda dos campos da parametrizacao de modalidades (P-PAR-1).
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. A rota da lista
 * vale tambem para a configuracao da modalidade, que fica abaixo dela. Ver
 * docs/FRONTEND.md, secao 6.
 */

const semEfeito = 'Guardado como parametro e sem efeito ate a homologacao da regra';

export const ajuda: Record<string, Record<string, string>> = {
  '/parametrizacao/modalidades': {
    'Taxa base (%)':
      'Taxa de partida da modalidade. Na abertura da operacao, ela e sugerida na Taxa aplicada quando o campo esta vazio.',
    'Codigo do ramo SUSEP':
      'Codigo do ramo na SUSEP, com quatro digitos, como 0775 (setor publico) ou 0776 (setor privado).',
    'Grupo de ramos SUSEP':
      'Os dois primeiros digitos do ramo SUSEP, como 07. O grupo e guardado separado do ramo.',
    'Numero do processo SUSEP':
      'Numero do processo SUSEP que aparece no titulo do ramo ou na modalidade. Texto livre, ate 60 caracteres.',
    'Nome da cobertura impresso':
      'Nome que o documento da apolice imprime em MODALIDADE/COBERTURA, que nao e o nome da modalidade. Vazio, o campo sai em branco. Ate 200 caracteres.',
    'Tipo do ramo':
      'Tipo do ramo. O significado provavel e o setor do segurado e ainda esta a confirmar com a seguradora.',
    'Nome do novo grupo':
      'Nome do grupo de modalidades, como Judicial ou Tradicional. Nao pode repetir no mesmo ramo, sem diferenciar maiusculas.',
    'Grupo de credito':
      'Classificacao usada pelo motor de credito e pelo limite do tomador por grupo. Vazio e nao classificado.',
    'Limite padrao de grupo economico': `${semEfeito} LIM-002. O motor continua usando o teto do conjunto de parametros dele.`,
    'Codigo do produto na seguradora':
      'Codigo do produto no sistema da seguradora. So e guardado.',
    'Ignorar ramo quando o segurado e pessoa fisica': `${semEfeito}. A seguradora ainda nao disse o efeito desta chave.`,
    'Ignorar ramo quando o segurado e privado': `${semEfeito}. A seguradora ainda nao disse o efeito desta chave.`,
    'Referencia de credito':
      'Liga a modalidade a linha da tabela do motor de credito. Escolher a referencia ja escolhe o grupo de credito dela.',
    'Valor maximo segurado': `${semEfeito} LIM-007. O motor de credito continua usando o valor do conjunto de parametros dele.`,
    'Valor maximo aprovado automaticamente': `${semEfeito} LIM-006. A aprovacao automatica continua pelo motor de credito.`,
    'Premio minimo': `${semEfeito} PRC-002. A cotacao continua sem conferir o premio minimo da modalidade.`,
    'Vigencia minima (dias)': `${semEfeito} SUB-004. Prazo em dias inteiros.`,
    'Vigencia maxima (dias)': `${semEfeito} SUB-004. Prazo em dias inteiros.`,
    'Codigo de referencia da seguradora':
      'Codigo da modalidade no sistema da seguradora. Muda na hora, com trilha; nao substitui o Codigo do SeguraCore.',
    'Maximo de dias futuros': `${semEfeito} SUB-010. Obrigatorio para a versao entrar em vigor.`,
    'Maximo de dias retroativos automaticos': `${semEfeito} SUB-009. Obrigatorio para a versao entrar em vigor.`,
    Automatico: `${semEfeito} SUB-009. Uma das tres tratativas de inicio de vigencia.`,
    Esteira: `${semEfeito} SUB-009. Uma das tres tratativas de inicio de vigencia.`,
    Hibrido: `${semEfeito} SUB-009. Uma das tres tratativas de inicio de vigencia.`,
    'Inativar modalidade':
      'Situacao do cadastro. Muda na hora, com trilha: modalidade inativa nao recebe operacao nova. A modalidade em rascunho so sai dele pela ativacao.',
    'Justificativa da ativacao':
      'Obrigatoria. Vai para a trilha com quem ativou e quem preparou o rascunho. Quem criou, carregou ou editou o rascunho nao o ativa (segregacao de funcoes).',
    'Modalidade habilitada para emissao automatica': `${semEfeito} CRD-015 e LIM-006.`,
    'Esta modalidade esta atuando como modalidade complementar': `${semEfeito} MOD-005.`,
    'Esta modalidade permite a inclusao de modalidade complementar': `${semEfeito} MOD-005.`,
    'Esta modalidade e restrita para os tomadores com ramos restritos': `${semEfeito} CAD-005. O motor continua usando a lista de modalidades bloqueadas dele.`,
    'As vigencias entre as modalidades e cobertura devem ser iguais': `${semEfeito}. A seguradora ainda nao disse o efeito desta chave.`,
    'Permite emissao com segurado Pessoa Fisica': `${semEfeito}. Depende do cadastro de segurado.`,
    'Permite inclusao de beneficiario': `${semEfeito}. Depende do cadastro de segurado.`,
    'Esta modalidade e monitorada': `${semEfeito} SUB-013.`,
    'Esta modalidade pode realizar a retomada do objeto (Step-in)': `${semEfeito} SUB-013.`,
    'Esta modalidade e de grande risco': `${semEfeito} SUB-013 e RES-003.`,
    'Cancelamento automatico de apolices vencidas': `${semEfeito} END-003. Nenhuma rotina cancela apolice.`,
    'Permite de uso de taxa por modalidade': `${semEfeito} MOD-007. A operacao continua usando a taxa base e a tabela de taxas.`,
    'Dias para o cancelamento automatico': `${semEfeito} END-003. Prazo em dias inteiros.`,
    'Dias para o cancelamento manual': `${semEfeito}. A seguradora ainda nao disse o uso deste prazo.`,
    'Taxa da modalidade (%)': `${semEfeito} MOD-007 e PRC-001. Em ate duas casas, guardada em pontos-base.`,
    'Acumulo habilitado para a modalidade': `${semEfeito} LIM-001 e LIM-004.`,
    'Esteira para data retroativa habilitada': `${semEfeito} SUB-009.`,
    'Modalidade de leiloeiro':
      'Chave para a modalidade de leiloeiro, a confirmar. So e guardada.',
    Justificativa:
      'Obrigatoria. Diz por que a versao entra em vigor. Quem abriu ou editou o rascunho nao ativa a versao.',

    // Textos, clausulas, coberturas, complementares e documentos (P-PAR-2).
    'Referencia da Seguradora':
      'Codigo ou referencia do texto no sistema da seguradora. Faz parte da versao do texto.',
    Label:
      'Nome do campo que a cotacao mostra para preencher a TAG, como Numero do contrato.',
    Tag: 'Marcacao da plataforma, em minusculas e sublinhado, sem as chaves: objeto.numero_contrato. A TAG nova comeca pelo grupo do texto (objeto. ou clausula.).',
    'Selecione o tipo':
      'Tipo do campo da TAG na cotacao: texto, editor de texto da esteira, data ou automatica. A lista completa ainda esta a confirmar.',
    'Incluir TAG':
      'Poe a marcacao no cursor do editor. As opcoes sao as TAGs declaradas no texto e o vocabulario dos textos da plataforma. O servidor recusa marcacao desconhecida ao salvar.',
    'Habilitar na cotacao':
      'O texto entra habilitado na cotacao. Guardado com a versao; a cotacao passa a le-lo com o pacote da cotacao.',
    Condicao:
      'Nome da condicao particular, como Clausula Beneficiario. Nao repete na modalidade, salvo a de outro tomador.',
    'Corretor pode inserir?': `${semEfeito} SUB-014. Marca a clausula que a corretora escolhe na cotacao.`,
    'Automatica Subscricao?': `${semEfeito} SUB-014. Marca a clausula aplicada automaticamente.`,
    'Clausula em branco': 'A clausula sem texto fixo: o texto e escrito na cotacao.',
    'Clausula agregadora':
      'Clausula agregadora, de significado a confirmar. So e guardada.',
    'Tomador da clausula':
      'Restringe a clausula a um tomador, como a clausula com nome de cliente. Vazio vale para todos. A restricao e guardada e a cotacao passa a le-la com o pacote dela.',
    Cobertura:
      'Nome da cobertura adicional, como Multa ou Trabalhista e Previdenciario. Nao repete na modalidade.',
    'Codigo de referencia': 'Codigo da cobertura no sistema da seguradora.',
    'Tipo de Calculo da Cobertura': `${semEfeito} MOD-006 e PRC-004. Agravamento ou distribuicao do premio; nenhum calculo le o tipo.`,
    'Taxa de agravamento (%)': `${semEfeito} MOD-006. Em ate duas casas, guardada em pontos-base.`,
    'Taxa de distribuicao (%)': `${semEfeito} F-10. Em ate duas casas, guardada em pontos-base.`,
    'Forma da importancia segurada': `${semEfeito} MOD-008. Igual a da basica, valor fixo ou percentual da basica.`,
    'Importancia segurada fixa': `${semEfeito} MOD-008. Vale quando a forma e valor fixo.`,
    'Percentual da basica (%)': `${semEfeito} MOD-008. Em ate duas casas, guardado em pontos-base.`,
    'Cobertura adicional':
      'Marca a cobertura como adicional. O que a distingue da secundaria esta a confirmar.',
    'Cobertura habilitada para emissao automatica': `${semEfeito} LIM-006.`,
    'Permite edicao manual na cotacao': `${semEfeito}. A seguradora ainda nao disse o que pode ser editado nem por quem.`,
    'Modalidade complementar': `Modalidade que pode entrar como complementar desta. ${semEfeito} MOD-005: a cotacao ainda nao a oferece.`,
    'Nome do documento': 'Nome do documento exigido. Nao repete na mesma lista.',
    Orientacao: 'Orientacao a quem envia o documento. Chave sem nome confirmado.',
    Obrigatorio: `${semEfeito} SUB-015 e CRD-017. Nenhuma esteira cobra o documento ainda.`,
  },
};
